// Windows has no dot-prefix convention for hidden files (hidden/system state is a filesystem
// attribute the browser's File API never exposes), so its metadata files can only be caught by
// exact name.
const kWindowsJunkFilenames = new Set(['thumbs.db', 'ehthumbs.db', 'desktop.ini'])

/**
 * Whether a file is an OS-generated metadata file (e.g. macOS' .DS_Store, Windows' Thumbs.db)
 * rather than something the user intentionally selected. These are silently walked in along
 * with real files when a folder is dropped, and should be skipped rather than surfaced as
 * "unsupported file type" errors.
 *
 * Any dot-prefixed name is treated as hidden/junk, matching the Unix/macOS hidden-file
 * convention itself rather than an enumerated list — this also covers macOS' AppleDouble
 * sidecar files (`._originalname`), which show up whenever a folder has touched a non-HFS+
 * volume (USB drives, network shares, exFAT) and aren't a single fixed name to list.
 */
export function isOsJunkFile(file: Pick<File, 'name'>): boolean {
  const name = file.name
  if (name.startsWith('.')) return true
  return kWindowsJunkFilenames.has(name.toLowerCase())
}
